import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
     const { slug: username } = useParams();
      const storageKey = `cartItems_${username}`;
    // استخدام lazy initialization لقراءة البيانات من localStorage عند التهيئة
    const [cartItems, setCartItems] = useState(() => {
        try {
            const savedItems = localStorage.getItem(storageKey);
    //   return saved ? JSON.parse(saved) : [];
            // const savedItems = localStorage.getItem('cartItems');
            if (savedItems) {
                const parsedItems = JSON.parse(savedItems);
                if (Array.isArray(parsedItems)) {
                    return parsedItems;
                }
            }
        } catch (error) {
            console.error('Error loading cart items:', error);
        }
        return [];
    });

    // حفظ التغييرات في localStorage عند كل تحديث على cartItems
    useEffect(() => {
        try {
            localStorage.setItem(storageKey, JSON.stringify(cartItems));
        } catch (error) {
            console.error('Error saving cart items:', error);
        }
    }, [storageKey,cartItems]);

    const addToCart = (item) => {
        setCartItems(prev => {
            // const existingItem = prev.find(i => i.slug === item.slug);
            const existing = prev.find(i => i.key === item.key);
            return existing ? prev : [...prev, { ...item }];
        });
    };

    const removeFromCart = (key) => {
        setCartItems(prev => prev.filter(item => item.key !== key));
        // setCartItems(prev => prev.filter(item => item.slug !== slug));
    };

    const updateQuantity = (key, quantity) => {
        const nextQty = Math.max(1, Math.floor(Number(quantity)) || 1);
        setCartItems((prev) =>
            prev.map((item) =>
                item.key === key ? { ...item, quantity: nextQty } : item
            )
        );
    };

    const clearCart = () => {
        setCartItems([]);
    };

    return (
        <CartContext.Provider
            value={{
                cartItems,
                addToCart,
                removeFromCart,
                updateQuantity,
                clearCart,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
